import { EMPTY_CUSTOMER_DETAILS_PAGE } from '@nx-ng/constants';
import { DEFAULT_TIMEZONE } from '@nx-ng/constants/timezone';
import { ICustomerDetailsPage } from '@nx-ng/types';
import { zonedTimeToUtc } from 'date-fns-tz';

import {
  CreateCustomerRequest,
  UpdateCustomerRequest,
  Customer,
} from '../client/src';

export const formatCustomerPageForCreate = ({
  customer,
  email,
}: {
  customer: ICustomerDetailsPage;
  email: string;
}): CreateCustomerRequest => {
  const { firstName, lastName, dateOfBirth, telephoneNumber, address } =
    customer.customerDetails;
  const { address1, address2, town, postCode } = address || {
    ...EMPTY_CUSTOMER_DETAILS_PAGE.customerDetails.address,
  };

  return {
    firstName: firstName ?? '',
    lastName: lastName ?? '',
    dateOfBirth: dateOfBirth
      ? zonedTimeToUtc(dateOfBirth, DEFAULT_TIMEZONE)
          .toISOString()
          .substring(0, 10)
      : '',
    emailAddress: email,
    telephoneNumber,
    address: {
      address1: address1 ?? '',
      address2,
      address3: undefined,
      town: town ?? '',
      postCode: postCode ?? '',
      county: undefined,
      country: undefined,
      company: undefined,
    },
    marketingPreferences: [
      {
        name: 'email',
        optIn: customer.preferences?.keepInTouch,
      },
    ],
  };
};

export const formatCustomerPageForUpdate = ({
  existingCustomer,
  updateCustomerDetails,
}: {
  existingCustomer: Customer;
  updateCustomerDetails: ICustomerDetailsPage;
}): UpdateCustomerRequest => {
  return {
    ...existingCustomer,
    ...formatCustomerPageForCreate({
      customer: updateCustomerDetails,
      email: existingCustomer.emailAddress!,
    }),
  };
};
